import styled from '@emotion/styled';
import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';
import { COLORS_BACKGROUND } from '../../styles/emotion/colors';
import { LinkV2 } from '../LinkV2';

export const InnerContainer = styled.div`
  padding: 0 ${SPACING.MD} ${SPACING.MD};
  background-color: ${COLORS_BACKGROUND.JEWEL_4};
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  ${MEDIA_QUERY.TABLET} {
    padding-left: 31px;
    padding-right: 31px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding-left: 38px;
    padding-right: 38px;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    padding-left: 62px;
    padding-right: 62px;
    padding-bottom: 60px;
  }
  ${MEDIA_QUERY.DESKTOP_XL} {
    padding-left: 70px;
    padding-right: 70px;
  }
`;

export const Content = styled.div`
  text-align: center;
  width: 100%;
  ${MEDIA_QUERY.DESKTOP} {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
`;

export const CakeImg = styled.img`
  width: 100%;
  ${MEDIA_QUERY.TABLET} {
    max-width: 480px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    max-width: 480px;
    max-height: 480px;
    text-align: right;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    max-width: 600px;
    max-height: 600px;
    text-align: right;
  }
`;

export const Actions = styled.div`
  align-self: flex-end;
  width: 100%;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${MEDIA_QUERY.NOT_MOBILE} {
    align-items: flex-start;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    margin-left: 34px;
  }
`;

export const Title = styled.h1`
  margin: 0 auto;
  margin-bottom: 30px;
  color: ${COLORS3.BLACK_100} ${FONT.textSizeRegular(FONT.FONT_SIZE_LARGER)} ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.LG};
    ${FONT.textSizeRegular(FONT.FONT_SIZE_HUGE)}
  }
  ${MEDIA_QUERY.DESKTOP} {
    margin: 0;
    margin-top: ${SPACING.XL};
    margin-bottom: ${SPACING.LG};
    ${FONT.textSizeRegular(FONT.FONT_SIZE_HUGE)}
    text-align: left;
    max-width: 350px;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    max-width: 400px;
  }
`;

export const Text = styled.p`
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  ${FONT.textSizeRegular(FONT.FONT_SIZE_REGULAR)}
  text-align: center;
  margin-bottom: 30px;
  ${MEDIA_QUERY.TABLET} {
    margin: 0 auto;
    margin-bottom: ${SPACING.LG};
    max-width: 500px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    margin: 0;
    margin-bottom: ${SPACING.LG};
    text-align: left;
    max-width: 380px;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    max-width: 520px;
  }
`;

export const StyledLinkV2 = styled(LinkV2)`
  margin: 0 auto;
  margin-bottom: ${SPACING.MD};
  ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.SM};
    &:last-of-type {
      margin-bottom: ${SPACING.XL};
    }
  }
  ${MEDIA_QUERY.DESKTOP} {
    margin: 0;
    margin-bottom: ${SPACING.SM};
    &:last-of-type {
      margin-bottom: ${SPACING.XL};
    }
    text-align: left;
  }
  ${MEDIA_QUERY.DESKTOP_LG} {
    &:last-of-type {
      margin-bottom: ${SPACING.XXL};
    }
  }
`;
